import { c as create_ssr_component } from "../../chunks/ssr.js";
const Error = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  return `<div style="display: flex;flex-direction:column;justify-content:center;align-items:center;padding_:4rem;height:100vh" data-svelte-h="svelte-1fdh6dh"><img src="/link-broken-svgrepo-com.svg" alt="Broken link" width="200"> <h1>Broken link</h1> </div>`;
});
export {
  Error as default
};
